// extracted by mini-css-extract-plugin
export var gridItem = "GridItem-module--gridItem--irFe+";
export var image = "GridItem-module--image--6h8jD";